var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHosting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    id: "clouddata",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 14.95,
    x2: 46.81,
    y1: 41.68,
    y2: 9.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9a9a9",
    className: "stopColor54a5ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c4",
    className: "stopColor8ad3fe svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 32,
    x2: 32,
    y1: 60,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e4e4",
    className: "stopColord3e6f5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorf0f7fc svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    y1: 48,
    y2: 36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    y1: 36,
    y2: 24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 17,
    x2: 21,
    y1: 54,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf",
    className: "stopColorfe9661 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b4b4",
    className: "stopColorffb369 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "f",
    x1: 23,
    x2: 27,
    y1: 54,
    y2: 54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "g",
    y1: 30,
    y2: 30
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "h",
    x1: 23,
    x2: 27,
    y1: 30,
    y2: 30
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "i",
    y1: 42,
    y2: 42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "j",
    x1: 23,
    x2: 27,
    y1: 42,
    y2: 42
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M59.83 24.14a7 7 0 0 0-5-3.09 11 11 0 0 0-.66-2.41A11.93 11.93 0 0 0 43 11a12.21 12.21 0 0 0-3.81.62 16 16 0 0 0-30.1 5.89 8.77 8.77 0 0 0-1.68.75l-.12.07a9.1 9.1 0 0 0-3 3 .54.54 0 0 0-.07.13A9 9 0 0 0 12 35h42a7 7 0 0 0 5.17-2.3A6.91 6.91 0 0 0 61 28a6.83 6.83 0 0 0-1.17-3.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 12,
    x: 13,
    y: 48,
    fill: "url(#a)",
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 12,
    x: 13,
    y: 36,
    fill: "url(#d)",
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 12,
    x: 13,
    y: 24,
    fill: "url(#e)",
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 54,
    r: 2,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 54,
    r: 2,
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M19 32a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M25 32a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 42,
    r: 2,
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 42,
    r: 2,
    fill: "url(#j)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting);
export default __webpack_public_path__ + "static/media/hosting.db40ce13f9fdc195e35d41b726b63373.svg";
export { ForwardRef as ReactComponent };